import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "count", "toggle"]

  connect() {
    this.updateCount()
  }

  toggleAll() {
    const visible = this.visibleCheckboxes()
    const allChecked = visible.length > 0 && visible.every(checkbox => checkbox.checked)

    visible.forEach(checkbox => {
      checkbox.checked = !allChecked
    })

    this.updateToggleLabel(!allChecked)
    this.updateCount()
  }

  updateCount() {
    const checked = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    const visible = this.visibleCheckboxes()

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${checked} of ${visible.length} selected`
    }

    const allChecked = visible.length > 0 && visible.every(checkbox => checkbox.checked)
    this.updateToggleLabel(allChecked)
  }

  // Private

  visibleCheckboxes() {
    return this.checkboxTargets.filter(checkbox => {
      const item = checkbox.closest("[data-list-search-target='item']")
      return !item || (!item.hidden && item.style.display !== "none")
    })
  }

  updateToggleLabel(allSelected) {
    if (this.hasToggleTarget) {
      this.toggleTarget.textContent = allSelected ? "Deselect All" : "Select All"
    }
  }
}
